import router from '../../helpers/router';
import { locationService } from '../../services';

// initial state
const state = {
    list: [],
    status: [],
};

// getters
const getters = {};

// actions
const actions = {
    list ({ dispatch, commit }, data) {
        return locationService
            .list(data)
            .then((nodes) => {
                commit('setList', nodes);

                return nodes;
            })
            .catch((error) => {
                commit('setList', []);
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },

    create ({ dispatch, commit }, { data }) {
        console.log('locationStore: add');
        commit('addRequest');

        return locationService
            .create(data)
            .then(() => {
                commit('addSuccess');
                dispatch('alert/success', { message: 'Vestiging is aangemaakt' }, { root: true }).then(() => {
                    router.push('/admin/locations');
                });
            })
            .catch((error) => {
                commit('addFailure');
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },

    update ({ dispatch, commit }, { id, data }) {
        console.log('locationStore: update');
        commit('updateRequest');

        return locationService
            .update(id, data)
            .then(() => {
                commit('updateSuccess');
                dispatch('alert/success', { message: 'Vestiging is gewijzigd' }, { root: true }).then(() => {
                    router.push('/admin/locations');
                });
            })
            .catch((error) => {
                commit('updateFailure');
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },
};

// mutations
const mutations = {
    setList (state, nodes) {
        state.list = nodes;
    },

    // add
    addRequest (state) {
        state.status = { adding: true };
    },
    addSuccess (state) {
        state.status = { added: true };
    },
    addFailure (state) {
        state.status = {};
    },

    // update
    updateRequest (state) {
        state.status = { updating: true };
    },
    updateSuccess (state) {
        state.status = { updated: true };
    },
    updateFailure (state) {
        state.status = {};
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
